import React from "react";
import { MapPin,Clock,CheckCircle,Car,Calendar,ChevronRight} from "lucide-react";

const OneWayDrop = ({setForm}) => {
    const oneWayRoutes = [
        {
            id: 1,
            route: "Chennai to Bangalore",
            from: "Chennai",
            to: "Bangalore",
            price: "₹8,500",
            distance: "350 km",
            time: "6-7 hours",
            popular: true,
            bestFor: ["Business Travel", "Family Trips", "Weekend Getaways"],
            features: [
                "No return charges",
                "Toll included",
                "Driver allowance included",
            ],
            vehicles: ["Swift Dzire", "Toyota Innova", "Tempo Traveller"],
            color: "from-blue-500 via-cyan-400 to-indigo-500",
            icon: "🚗",
        },
        {
            id: 2,
            route: "Chennai to Coimbatore",
            from: "Chennai",
            to: "Coimbatore",
            price: "₹9,500",
            distance: "500 km",
            time: "8-9 hours",
            popular: true,
            bestFor: ["Business Travel", "Hill Station Tours"],
            features: ["Scenic route", "Comfort stops", "AC vehicle"],
            vehicles: ["Toyota Innova", "Mahindra Xylo", "Force Traveller"],
            color: "from-purple-500 via-pink-400 to-rose-500",
            icon: "🏞️",
        },
        {
            id: 3,
            route: "Chennai to Madurai",
            from: "Chennai",
            to: "Madurai",
            price: "₹7,000",
            distance: "450 km",
            time: "7-8 hours",
            popular: true,
            bestFor: ["Temple Tours", "Family Trips"],
            features: ["Temple route expert", "Flexible timings"],
            vehicles: ["Swift Dzire", "Toyota Innova", "Chevrolet Tavera"],
            color: "from-emerald-500 via-teal-400 to-green-500",
            icon: "🛕",
        },
        {
            id: 4,
            route: "Chennai to Trichy",
            from: "Chennai",
            to: "Trichy",
            price: "₹5,500",
            distance: "320 km",
            time: "5-6 hours",
            popular: true,
            bestFor: ["Quick Business Trips", "Weekend Travel"],
            features: ["Express service", "Early morning departures"],
            vehicles: ["Swift Dzire", "Mahindra Marazzo"],
            color: "from-orange-500 via-amber-400 to-yellow-500",
            icon: "⚡",
        },
        {
            id: 5,
            route: "Chennai to Pondicherry",
            from: "Chennai",
            to: "Pondicherry",
            price: "₹3,500",
            distance: "150 km",
            time: "3-4 hours",
            popular: false,
            bestFor: ["Beach Holidays", "Weekend Getaways"],
            features: ["Coastal route", "French colony tours"],
            vehicles: ["Swift Dzire", "Toyota Innova"],
            color: "from-rose-500 via-pink-400 to-fuchsia-500",
            icon: "🏖️",
        },
        {
            id: 6,
            route: "Chennai to Vellore",
            from: "Chennai",
            to: "Vellore",
            price: "₹2,800",
            distance: "130 km",
            time: "2-3 hours",
            popular: false,
            bestFor: ["Medical Tourism", "Day Trips"],
            features: ["Hospital drop service", "Quick returns"],
            vehicles: ["Swift Dzire", "Mahindra Xylo"],
            color: "from-cyan-500 via-blue-400 to-indigo-500",
            icon: "🏥",
        },
        {
            id: 7,
            route: "Chennai to Salem",
            from: "Chennai",
            to: "Salem",
            price: "₹4,500",
            distance: "340 km",
            time: "5-6 hours",
            popular: false,
            bestFor: ["Business Travel", "Textile Industry Visits"],
            features: ["Industrial route expert", "Flexible pickup"],
            vehicles: ["Swift Dzire", "Toyota Innova"],
            color: "from-lime-500 via-green-400 to-emerald-500",
            icon: "🏭",
        },
        {
            id: 8,
            route: "Chennai to Tirupati",
            from: "Chennai",
            to: "Tirupati",
            price: "₹4,000",
            distance: "130 km",
            time: "2-3 hours",
            popular: true,
            bestFor: ["Pilgrimage", "Day Trips"],
            features: ["Temple darshan assistance", "Early morning service"],
            vehicles: ["Swift Dzire", "Toyota Innova", "Tempo Traveller"],
            color: "from-violet-500 via-purple-400 to-indigo-500",
            icon: "🕉️",
        },
        {
            id: 9,
            route: "Chennai to Kumbakonam",
            from: "Chennai",
            to: "Kumbakonam",
            price: "₹4,200",
            distance: "280 km",
            time: "5-6 hours",
            popular: false,
            bestFor: ["Temple Tours", "Cultural Trips"],
            features: ["Temple circuit expert", "Multi-stop tours"],
            vehicles: ["Swift Dzire", "Toyota Innova"],
            color: "from-yellow-500 via-orange-400 to-amber-500",
            icon: "🎎",
        },
        {
            id: 10,
            route: "Chennai to Chidambaram",
            from: "Chennai",
            to: "Chidambaram",
            price: "₹3,800",
            distance: "230 km",
            time: "4-5 hours",
            popular: false,
            bestFor: ["Temple Tours", "Cultural Visits"],
            features: ["Dance festival specials", "Cultural guide available"],
            vehicles: ["Swift Dzire", "Mahindra Xylo"],
            color: "from-sky-500 via-blue-400 to-cyan-500",
            icon: "💃",
        },
        {
            id: 11,
            route: "Chennai to Thanjavur",
            from: "Chennai",
            to: "Thanjavur",
            price: "₹5,500",
            distance: "340 km",
            time: "6-7 hours",
            popular: false,
            bestFor: ["Heritage Tours", "Art & Culture"],
            features: ["Heritage site expert", "Museum visits included"],
            vehicles: ["Toyota Innova", "Force Traveller"],
            color: "from-fuchsia-500 via-pink-400 to-rose-500",
            icon: "🏛️",
        },
        {
            id: 12,
            route: "Chennai to Erode",
            from: "Chennai",
            to: "Erode",
            price: "₹6,500",
            distance: "400 km",
            time: "7-8 hours",
            popular: false,
            bestFor: ["Textile Business", "Industrial Visits"],
            features: ["Textile market expert", "Factory visit arrangements"],
            vehicles: ["Toyota Innova", "Mahindra Marazzo"],
            color: "from-amber-500 via-orange-400 to-red-500",
            icon: "👔",
        },
    ];

    // Popular Cities
    const popularCities = [
        { name: "Bangalore", icon: "🏙️", trips: 150 },
        { name: "Coimbatore", icon: "🏞️", trips: 120 },
        { name: "Madurai", icon: "🛕", trips: 180 },
        { name: "Trichy", icon: "⚡", trips: 200 },
        { name: "Pondicherry", icon: "🏖️", trips: 90 },
        { name: "Tirupati", icon: "🕉️", trips: 250 },
    ];

    return (
        <div className="text-white">

            {/* Popular Destinations */}
            <section className="py-12">
                <div className="container mx-auto px-4">
                    <div className="max-w-6xl mx-auto">
                        <div className="text-center mb-12">
                            <h2 className="text-3xl font-bold text-white mb-4">
                                Popular Destinations
                            </h2>
                            <p className="text-white max-w-2xl mx-auto">
                                Most frequently booked one-way drop routes
                            </p>
                        </div>

                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-12">
                            {popularCities.map((city, index) => (
                                <div
                                    key={index}
                                    className="bg-white rounded-2xl p-4 shadow-lg border border-gray-200 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 text-center"
                                >
                                    <div className="text-3xl mb-2">
                                        {city.icon}
                                    </div>
                                    <h3 className="font-bold text-gray-900 mb-1">
                                        {city.name}
                                    </h3>
                                    <div className="text-sm text-gray-600">
                                        {city.trips}+ trips/month
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* All Routes Section */}
            <section className="py-12 text-white">
                <div className="container mx-auto px-4">
                    <div className="max-w-6xl mx-auto">
                        <div className="text-center mb-12">
                            <h2 className="text-3xl font-bold text-white mb-4">
                                All One-Way Drop Routes
                            </h2>
                            <p className="text-white max-w-2xl mx-auto">
                                Fixed price service to major destinations from
                                Chennai
                            </p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {oneWayRoutes.map((route) => (
                                <div
                                    key={route.id}
                                    className={`bg-gradient-to-br ${route.color} rounded-2xl shadow-xl hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-500 overflow-hidden group`}
                                >
                                    <div className="bg-white/70 backdrop-blur-sm p-6">
                                        {/* Route Header */}
                                        <div className="flex justify-between items-start mb-4">
                                            <div className="flex items-center">
                                                <div className="text-2xl mr-3">
                                                    {route.icon}
                                                </div>
                                                <div>
                                                    <h3 className="text-xl font-bold text-gray-900">
                                                        {route.route}
                                                    </h3>
                                                    {route.popular && (
                                                        <span className="inline-block px-2 py-1 bg-gradient-to-r from-yellow-400 to-orange-400 text-white text-xs font-bold rounded-full mt-1 shadow-sm">
                                                            POPULAR ROUTE
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="text-right">
                                                <div className="text-2xl font-bold text-gray-900">
                                                    {route.price}
                                                </div>
                                                <div className="text-sm text-gray-600">
                                                    Fixed Price
                                                </div>
                                            </div>
                                        </div>

                                        {/* Route Details */}
                                        <div className="space-y-3 mb-6">
                                            <div className="flex items-center text-gray-700">
                                                <MapPin className="h-4 w-4 mr-2 text-blue-500" />
                                                <span className="font-medium">
                                                    {route.distance}
                                                </span>
                                                <span className="mx-2">•</span>
                                                <Clock className="h-4 w-4 mr-2 text-purple-500" />
                                                <span className="font-medium">
                                                    {route.time}
                                                </span>
                                            </div>

                                            <div className="flex items-center text-gray-700">
                                                <Car className="h-4 w-4 mr-2 text-emerald-500" />
                                                <span>
                                                    Available:{" "}
                                                    {route.vehicles.join(", ")}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Best For */}
                                        <div className="mb-4">
                                            <div className="text-sm font-semibold text-gray-800 mb-2">
                                                Best For:
                                            </div>
                                            <div className="flex flex-wrap gap-2">
                                                {route.bestFor.map(
                                                    (purpose, idx) => (
                                                        <span
                                                            key={idx}
                                                            className="px-3 py-1 bg-white/80 backdrop-blur-sm text-gray-800 text-xs font-medium rounded-full shadow-sm"
                                                        >
                                                            {purpose}
                                                        </span>
                                                    )
                                                )}
                                            </div>
                                        </div>

                                        {/* Features */}
                                        <div className="space-y-2 mb-6">
                                            {route.features.map(
                                                (feature, idx) => (
                                                    <div
                                                        key={idx}
                                                        className="flex items-center text-sm text-gray-700"
                                                    >
                                                        <CheckCircle className="h-4 w-4 mr-2 text-emerald-500 flex-shrink-0" />
                                                        {feature}
                                                    </div>
                                                )
                                            )}
                                        </div>

                                        {/* Action Button */}
                                        <button onClick={() => setForm(true)}
                                        className="w-full py-3 bg-gradient-to-r from-gray-900 to-black text-white rounded-xl font-semibold hover:shadow-lg hover:shadow-gray-900/30 transition-all duration-300 shadow-md group-hover:scale-105">
                                            <span className="flex items-center justify-center">
                                                <Calendar className="mr-2 h-5 w-5" />
                                                {"Book Now"}
                                                <ChevronRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* Custom CSS */}
            <style jsx global>{`
                @keyframes blob {
                    0% {
                        transform: translate(0px, 0px) scale(1);
                    }
                    33% {
                        transform: translate(30px, -50px) scale(1.1);
                    }
                    66% {
                        transform: translate(-20px, 20px) scale(0.9);
                    }
                    100% {
                        transform: translate(0px, 0px) scale(1);
                    }
                }

                .animate-blob {
                    animation: blob 7s infinite;
                }

                .animation-delay-2000 {
                    animation-delay: 2s;
                }

                .animation-delay-4000 {
                    animation-delay: 4s;
                }

                @keyframes gradient {
                    0%,
                    100% {
                        background-position: 0% 50%;
                    }
                    50% {
                        background-position: 100% 50%;
                    }
                }

                .animate-gradient {
                    animation: gradient 3s ease infinite;
                    background-size: 200% 200%;
                }
            `}</style>
        </div>
    );
};

export default OneWayDrop;
